import { render } from "./ProductLightened.vue?vue&type=template&id=2cea617a&scoped=true"
import script from "./ProductLightened.vue?vue&type=script&lang=js"
export * from "./ProductLightened.vue?vue&type=script&lang=js"

import "./ProductLightened.vue?vue&type=style&index=0&id=2cea617a&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cea617a"],['__file',"src/components/products/ProductLightened.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cea617a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cea617a', __exports__)) {
    console.log('reload')
    api.reload('2cea617a', __exports__)
  }
  
  module.hot.accept("./ProductLightened.vue?vue&type=template&id=2cea617a&scoped=true", () => {
    console.log('re-render')
    api.rerender('2cea617a', render)
  })

}


export default __exports__